import gsap from 'gsap';
import { FC, ReactNode, useCallback, useEffect, useRef } from 'react';
import { NAME_TEXT_SIZE, PADDING } from 'custom-constants';
import { Graphics } from '@inlet/react-pixi';
import * as PIXI from 'pixi.js';
import { NameBadge } from '../NameBadgeComponent';
import { CustomPixiContainer } from '../CustomPixiContainer';

interface Props {
  contentWidth: number;
  contentHeight: number;
  sumAnswersSize: number;
  textHeight: number;
  bubblePosX: number;
  bubblePosY: number;
  text: string;
  name?: string;
  children: ReactNode;
}

export const BorderComponent: FC<Props> = ({
  contentWidth,
  contentHeight,
  sumAnswersSize,
  textHeight,
  bubblePosX,
  bubblePosY,
  text,
  name,
  children,
}) => {
  const borderRef = useRef(null);

  useEffect(() => {
    gsap.to(borderRef.current, {
      alpha: 0,
      duration: 0,
    });
    gsap.to(borderRef.current, {
      alpha: 1,
    });
  }, [text]);

  const drawMessageBorder = useCallback(
    (g: PIXI.Graphics) => {
      g.lineStyle(2, 0xf1f1f1, 1);
      g.beginFill(0xffffff, 0.8);
      g.drawRoundedRect(0, 0, contentWidth + PADDING * 2, textHeight + PADDING * 2, 15);
      g.endFill();
      g.lineStyle(0);
    },
    [contentWidth, textHeight]
  );

  return (
    <CustomPixiContainer
      x={bubblePosX}
      y={bubblePosY - sumAnswersSize}
      width={contentWidth}
      height={contentHeight}
      forwardRef={borderRef}
    >
      <Graphics key={textHeight} draw={drawMessageBorder} />
      <NameBadge
        name={name}
        x={20}
        y={-NAME_TEXT_SIZE}
        height={contentHeight}
        width={contentWidth - 20}
        textSize={NAME_TEXT_SIZE}
      />
      {children}
    </CustomPixiContainer>
  );
};
